var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailContactIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5325",
    "data-name": "Group 5325",
    transform: "translate(-404.5 -363.757)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Base",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(405 364.257)",
    fill: "#FF3535",
    stroke: "#FF3535",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "email-svgrepo-com",
    d: "M11.638,15.724H8.862A6.862,6.862,0,0,1,4.01,4.01,6.862,6.862,0,0,1,15.724,8.862V9.9a2.35,2.35,0,0,1-4.35,1.235,3.39,3.39,0,1,1,.879-2.276V9.9a1.12,1.12,0,0,0,2.239,0V8.862a5.631,5.631,0,1,0-5.631,5.631h2.776a.615.615,0,0,1,0,1.231ZM8.862,6.7a2.161,2.161,0,1,0,2.161,2.161A2.163,2.163,0,0,0,8.862,6.7Z",
    transform: "translate(411.923 371.18)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailContactIcon);
export default __webpack_public_path__ + "static/media/email-contact-icon.7279c9c31eb1a4cf0a271e8ccbe23e86.svg";
export { ForwardRef as ReactComponent };